export default {
    baseStyle: {
        formlabel: {
            width: {base: '100%', md: '47%'},
            marginBottom: '0',
            fontSize: '13px',
            fontWeight: '700'
        }
    }
}
